module.exports = window["PropTypes"];